import Vue from 'vue'
import YunTableList from '@yld/yun-table-list'
import YunTableNav from '@yld/yun-table-list/components/tableNav/index.vue'
import { router } from '@geek/yum-freight-framework'
import {
  filterEnglishNameList,
  filterEnglishNameTableSource,
  hasEnglishNameField,
  isGoFreightUser,
  syncGoFreightTableColumns
} from '@/utils/goFreight'

function getComponentOptions(component) {
  return component?.options ?? component
}

function appendHook(options, key, fn) {
  if (!options) return
  const existing = options[key]
  if (Array.isArray(existing)) {
    existing.push(fn)
  } else if (existing) {
    options[key] = [existing, fn]
  } else {
    options[key] = [fn]
  }
}

function filterTableListColumns(vm) {
  if (!isGoFreightUser()) return
  filterEnglishNameTableSource(vm.tableSource)
  if (hasEnglishNameField(vm.tableColumn)) {
    vm.tableColumn = filterEnglishNameList(vm.tableColumn)
  }
}

function patchYunTableList() {
  const options = getComponentOptions(YunTableList)
  if (!options?.methods?.changeColumn) return

  appendHook(options, 'mounted', function goFreightTableMounted() {
    filterTableListColumns(this)
  })

  appendHook(options, 'beforeUpdate', function goFreightTableBeforeUpdate() {
    filterTableListColumns(this)
  })

  const originChangeColumn = options.methods.changeColumn
  options.methods.changeColumn = function patchedChangeColumn(val) {
    const columns = isGoFreightUser() ? filterEnglishNameList(val) : val
    return originChangeColumn.call(this, columns)
  }
}

function patchYunTableNav() {
  const options = getComponentOptions(YunTableNav)
  if (!options?.methods?.getColumnList) return

  const originGetColumnList = options.methods.getColumnList
  options.methods.getColumnList = function patchedGetColumnList(data = []) {
    originGetColumnList.call(this, data)
    if (!isGoFreightUser() || !this.columnData?.selectColumn) return
    this.columnData.selectColumn = filterEnglishNameList(this.columnData.selectColumn)
    if (this.$listeners.changeColumn) {
      this.$emit('changeColumn', this.columnData.selectColumn)
    }
  }
}

function setupRouterSync() {
  router.afterEach(() => {
    Vue.nextTick(() => {
      if (router.app) {
        syncGoFreightTableColumns(router.app)
      }
    })
  })
}

export default function installGoFreightPlugin() {
  patchYunTableList()
  patchYunTableNav()
  setupRouterSync()
}
